import { environment } from '@monorepo-channels/shared/util-environments'
import { CommonModule } from '@angular/common'
import { Component, inject, ViewChild } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { Router, RouterLink, RouterOutlet } from '@angular/router'
import { UserProfileComponent } from '@monorepo-channels/components/ui-pm'
import { ExitComponent, SelectThemeOptionsComponent } from '@monorepo-channels/feature-pm'
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { take } from 'rxjs'
import { getClient } from '@monorepo-channels/channels/domain'
import { Store } from '@ngrx/store'
import { MatDialog } from '@angular/material/dialog'
import { MatListItem, MatListModule, MatNavList } from '@angular/material/list'
import { DivisorUiComponent } from '@monorepo-channels/components/ui-common'
import {
	MatSidenav,
	MatSidenavContainer,
	MatSidenavContent,
	MatSidenavModule,
} from '@angular/material/sidenav'
import { MatToolbarModule } from '@angular/material/toolbar'
import { isMobile, MenuOpened, openResponsiveComponent } from '@monorepo-channels/shared/util-helpers'
import { MatBottomSheet } from '@angular/material/bottom-sheet'

@Component({
	standalone: true,
	imports: [
		CommonModule,
		MatSidenavModule,
		MatButtonModule,
		RouterLink,
		RouterOutlet,
		MatIcon,
		MatListItem,
		DivisorUiComponent,
		MatNavList,
		MatSidenav,
		MatSidenavContainer,
		MatSidenavContent,
		UserProfileComponent,
		MatToolbarModule,
		MatIconModule,
		MatListModule,
		MatButtonModule,
	],
	selector: 'pm-menu-mobile',
	templateUrl: './menu-mobile.component.html',
	styleUrl: './menu-mobile.component.scss',
})
export class MenuMobileComponent {
	private store = inject(Store)
	public client$ = this.store.select(getClient)
	public dialog = inject(MatDialog)
	public bottomSheet = inject(MatBottomSheet)
	public router = inject(Router)
	private menuOpened = inject(MenuOpened)
	isMobile = isMobile()
	sidenavMode: 'over' | 'side' = this.isMobile ? 'over' : 'side'
	showChangeTheme = !environment.production

	@ViewChild('sidenav') sidenav!: MatSidenav

	toggle() {
		this.sidenav.toggle()
		this.menuOpened.sidenavOpened = this.sidenav.opened
	}

	onOpenedChange(opened: boolean) {
		this.menuOpened.sidenavOpened = opened
	}

	changeTheme() {
		openResponsiveComponent({
			component: SelectThemeOptionsComponent,
			isMobile: this.isMobile,
			bottomSheet: this.bottomSheet,
			dialog: this.dialog,
		})
	}

	logout() {
		this.client$.pipe(take(1)).subscribe(client => {
			openResponsiveComponent({
				component: ExitComponent,
				isMobile: this.isMobile,
				bottomSheet: this.bottomSheet,
				dialog: this.dialog,
				config: { data: { client: client?.firstName } },
			})
		})
	}
}
